import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TermsAndPrivacyWrapper = styled.div({
	paddingTop: token('space.300', '24px'),
	paddingBottom: token('space.300', '24px'),
	width: '462px',
	textAlign: 'center',
	margin: 'auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MainContentWrapper = styled.div({
	display: 'flex',
	'flex-direction': 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CenterContentWrapper = styled.div({
	display: 'flex',
	'flex-direction': 'row',
	'justify-content': 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentBox = styled.div({
	display: 'inline',
	padding: token('space.800', '24px'),
	width: '362px',
	//flex: grow,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageTitleStyleWrapper = styled.div({
	'font-size': '24px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ListContainer = styled.ul({
	paddingBottom: token('space.100', '14px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ListItem = styled.li({
	paddingTop: token('space.100', '14px'),
	paddingBottom: token('space.100', '14px'),
	'font-size': '14px',
});
